const getGitCommitHashVersion = () => {
  return '___COMMIT___';
};

export default getGitCommitHashVersion;
